<template>
    <v-container
        fluid
        class="pa-6">
        <div class="headline font-weight-bold pb-4">
            {{ $t('menu.ticketAndAddOns') }}
        </div>

        <product-list-view
            class="productListView"
            :tickets="tickets"
            :ticketPagination="ticketPagination"
            :addOns="addOns"
            :addOnPagination="addOnPagination"
            :kabanas="kabanas"
            :kabanaPagination="kabanaPagination"/>
    </v-container>
</template>

<script>
import ProductListView from '@/views/ProductListView'

import { mapState } from 'vuex'

export default {
    name: 'ProductListPage',

    components: {
        ProductListView
    },

    data () {
        return {
            ticketPagination: {
                itemsPerPage: 50
            },
            addOnPagination: {
                itemsPerPage: 50
            },
            kabanaPagination: {
                itemsPerPage: 50
            }
        }
    },

    computed: {
        ...mapState('product', ['tickets', 'addOns', 'kabanas'])
    },

    mounted () {
        this.fetchTickets()
        this.fetchAddOns()
        this.fetchKabanas()
    },

    methods: {
        fetchTickets () {
            this.$store.dispatch('product/fetchTickets')
        },

        fetchAddOns () {
            this.$store.dispatch('product/fetchAddOns')
        },

        fetchKabanas () {
            this.$store.dispatch('product/fetchKabanas')
        }
    }
}
</script>

<style lang="scss" scoped></style>
